import React from "react";
import {
    ArrowDown, ArrowUp, BookmarkPlus, Copy, Eye, EyeOff, Palette, Plus, Settings2, Trash2,
} from "lucide-react";
import { SiteRenderer } from "./SiteRenderer";
import { postEdit } from "../lib/productPreview";

const TOOLS = [
    { action: "inspect", icon: Settings2, title: "All settings" },
    { action: "style", icon: Palette, title: "Colour" },
    { action: "up", icon: ArrowUp, title: "Move up" },
    { action: "down", icon: ArrowDown, title: "Move down" },
    { action: "duplicate", icon: Copy, title: "Duplicate" },
    { action: "preset", icon: BookmarkPlus, title: "Save as preset" },
    { action: "delete", icon: Trash2, title: "Delete" },
];

/** Product-page custom sections. In the CRM preview every section gets its own toolbar. */
export const PreviewSections = ({ sections = [], editing = false }) => {
    if (!editing) return <SiteRenderer sections={sections} />;

    return (
        <div data-testid="pv-extras">
            {sections.map((s) => {
                const hidden = s.visible === false;
                return (
                    <div key={s.id} className="relative rhm-frame" data-testid={`pv-section-${s.id}`}>
                        <div className="absolute top-2 right-2 z-40 flex items-center gap-0.5 bg-black/85 border border-white/15 px-1 py-1"
                            onClick={(e) => e.stopPropagation()}>
                            <button type="button" title={hidden ? "Show" : "Hide"}
                                data-testid={`pv-tool-hide-${s.id}`}
                                onClick={(e) => { e.stopPropagation(); postEdit({ kind: "section-action", id: s.id, action: "hide" }); }}
                                className="p-1.5 text-zinc-400 hover:text-gold">
                                {hidden ? <EyeOff className="w-3.5 h-3.5" /> : <Eye className="w-3.5 h-3.5" />}
                            </button>
                            {TOOLS.map((t) => (
                                <button key={t.action} type="button" title={t.title}
                                    data-testid={`pv-tool-${t.action}-${s.id}`}
                                    onClick={(e) => { e.stopPropagation(); postEdit({ kind: "section-action", id: s.id, action: t.action }); }}
                                    className={`p-1.5 text-zinc-400 ${t.action === "delete" ? "hover:text-red-400" : "hover:text-gold"}`}>
                                    <t.icon className="w-3.5 h-3.5" />
                                </button>
                            ))}
                        </div>
                        <div className={hidden ? "opacity-35" : ""}>
                            <SiteRenderer sections={[s]} editing selectedId={s.id}
                                onSelect={() => postEdit({ kind: "section-action", id: s.id, action: "select" })}
                                onEditText={(p) => postEdit({
                                    kind: "section-text", id: s.id, field: p.field,
                                    value: p.value, multiline: p.multiline,
                                })} />
                        </div>
                    </div>
                );
            })}
            <div className="mx-auto max-w-7xl px-6 md:px-12 py-10 flex justify-center">
                <button type="button" data-testid="pv-add-section"
                    onClick={() => postEdit({ kind: "add-section" })}
                    className="inline-flex items-center gap-2 border border-dashed border-gold/60 text-gold px-6 py-3
                        mono text-[10px] tracking-[0.2em] hover:bg-gold hover:text-black transition-colors">
                    <Plus className="w-3.5 h-3.5" /> ADD A SECTION HERE
                </button>
            </div>
        </div>
    );
};

export default PreviewSections;
